import React from 'react';

import { SpeakerGird } from './SpeakerGird';
import { FormattedMessage } from 'react-intl';

import styles from './index.module.css';

export function SpeakerList() {
  return (
    <div className={styles.speakerWrap}>
      <div className={styles.header}>
        <div className={styles.title}>
          <FormattedMessage id="ourSpeackers" />
        </div>
        <div className={styles.horizontal}></div>
      </div>
      <SpeakerGird />
    </div>
  );
}
